import { useEffect, useState } from "react";
import { Autocomplete, DialogContent, Grid } from "@mui/material";
import MDButton from "components/MDButton";
import { useDispatch, useSelector } from "react-redux";
import MDDialog from "components/MDDialog";
import MDSnackbar from "components/MDSnackbar";
import { Formik } from "formik";
import { useMaterialUIController } from "context";
import CircularIndeterminate from "components/MDLoading";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import { updateLicensePlate } from "store/slice/reservation/reservationSlice";
import { getSpaces } from "store/slice/space/spaceSlice";
import { updateSpaceNumber } from "store/slice/reservation/reservationSlice";

const SpaceNumberUpdate = (props) => {
  const dispatch = useDispatch();
  const { dialogOpen, onClose, data, getReservationsData, placeId } = props;
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const [isLoading, setIsLoading] = useState(false);
  const spaceData = useSelector((state) => state.spaces?.spaces);

  const [notification, setNotification] = useState({
    color: "",
    icon: "",
    title: "",
    content: "",
    show: false,
    close: () => setNotification({ ...notification, show: false }),
  });

  console.log("data ====>", data);

  useEffect(() => {
    dispatch(getSpaces(placeId));
  }, [dispatch, placeId]);

  const handelUpdateSpaceNumber = async (payload) => {
    console.log("payload ---->", payload);
    setIsLoading(true);
    await dispatch(updateSpaceNumber(payload))
      .unwrap()
      .then(async (res) => {
        const success = res?.success;
        if (success) {
          getReservationsData();
          setIsLoading(false);
          onClose();
        }
        setIsLoading(false);
        setNotification({
          ...notification,
          color: success ? "success" : "error",
          title: success ? "Success" : "Error",
          content: res?.message,
          icon: success ? "check" : "warning",
          show: true,
        });
        // onClose();
      })
      .catch((err) => {
        console.error("Error getting cancel:", err);
      });
  };

  return (
    <>
      <CircularIndeterminate
        type="full"
        size={20}
        text="Updating Space Number..."
        open={isLoading}
      />
      <MDSnackbar
        color={notification.color}
        icon={notification.icon}
        title={notification.title}
        content={notification.content}
        open={notification.show}
        close={notification.close}
        bgWhite
      />
      <MDDialog
        dialogTitle="Space Number Update"
        open={dialogOpen}
        dialogClose={onClose}
        closeIcon={true}
        maxWidth="sm"
      >
        <DialogContent>
          <Formik
            initialValues={{
              reservationId: data?.reservationId || "",
              spaceId: data?.spaceId || "",
              purpose: "PARKING",
            }}
            onSubmit={(value, action) => {
              const payload = {
                ...value,
                spaceId: value.spaceId,
              };
              handelUpdateSpaceNumber(payload);
            }}
          >
            {(props) => (
              <form onSubmit={props.handleSubmit}>
                <Grid container spacing={2} className="mt-1">
                  {!props.values.fullRefund && (
                    <>
                      <Grid item xs={12}>
                        <Autocomplete
                          disableClearable
                          name="spaceId"
                          value={
                            spaceData.find(
                              (s) => s._id === props.values.spaceId
                            ) || null
                          }
                          options={spaceData.filter((space) => space.isPrimary)}
                          onChange={(event, newValue) => {
                            props.setFieldValue("spaceId", newValue?._id);
                          }}
                          onBlur={props.handleBlur}
                          getOptionLabel={(option) => option?.title || ""}
                          renderInput={(params) => (
                            <MDInput
                              label="Select Space"
                              fullWidth
                              {...params}
                            />
                          )}
                        />
                      </Grid>
                    </>
                  )}
                  <Grid item xs={12}>
                    <MDBox display="flex" justifyContent="end" gap={2}>
                      <MDButton
                        color="danger"
                        variant="contained"
                        onClick={onClose}
                      >
                        Cancel
                      </MDButton>
                      <MDButton
                        color={sidenavColor}
                        variant="contained"
                        type="submit"
                      >
                        Update
                      </MDButton>
                    </MDBox>
                  </Grid>
                </Grid>
              </form>
            )}
          </Formik>
        </DialogContent>
      </MDDialog>
    </>
  );
};

export default SpaceNumberUpdate;
